export default __webpack_public_path__ + "static/media/logo-bookmark.d426263a.svg";